import { EventEmitter } from "@angular/core";
import { getEmptyField } from "@core/_utils/tools.utils";
import { LineRequest } from "./line-request";

export class HeaderRequest {
    id: number;
    name: string;
    desc: string;
    visibility: any;
    listVisibility: any[];
    userListUsed: any[];
    groupListUsed: any[];
    idresult: number;
    emptyField: boolean;
    reqDetail: any[];

    notifyParent: EventEmitter<any> = new EventEmitter(); 

    public Clear() {
        this.id = 0;
        this.name = '';
        this.desc = '';
        this.visibility = null;
        this.listVisibility = [];
        this.userListUsed = [];
        this.groupListUsed = [];
        this.idresult = 0;
        this.emptyField = true;
    }
    public loadVisibility(atype, avisibility) {
        for (let i = 0; i < avisibility.length; i++) {
            this.listVisibility.push({
                label: avisibility[i].name,
                value: { id: avisibility[i].id, name: avisibility[i].name },
            });
        }
    }

    public load(adata){
        this.id = adata.id;
        this.name = adata.label;
        this.desc = adata.description;
        this.visibility = adata.visibility;
        this.idresult = adata.idResult;
        this.emptyField = getEmptyField(adata.emptyfield);
        if (this.visibility === 1) {
            this.groupListUsed = [...this.getAccessList(adata)];
        }
        if (this.visibility === 2) {
            this.userListUsed = [...this.getAccessList(adata)];
        }
        this.reqDetail = [...this.getReqDetail(adata)];
        this.notifyParent.emit();
    }      

    private getReqDetail(adata) {
        let wReqDetail = [];
        if (adata.webReqDetails.length > 0) {
            for (let i = 0; i < adata.webReqDetails.length; i++) {
                let witem = new LineRequest();
                witem.Name = adata.webReqDetails[i].name;
                if (adata.webReqDetails[i].label === null) {
                    witem.Label = witem.Name;
                } else {
                    witem.Label = adata.webReqDetails[i].label;
                }
                witem.DefaultValue = adata.webReqDetails[i].valdefault;
                witem.Visible = getEmptyField(adata.webReqDetails[i].visible);
                witem.Search = getEmptyField(adata.webReqDetails[i].search);
                witem.Field = adata.webReqDetails[i].field;
                witem.Type = adata.webReqDetails[i].type;
                witem.Operat = adata.webReqDetails[i].operator;
                witem.DisplayDefault = getEmptyField(this.getDisplayDefault(adata.webReqDetails[i].displaydefault));
                witem.noligne = i;
                wReqDetail.push(witem);
            }
        }
        return wReqDetail;
    }

    private getAccessList(adata) {
        let wAccessList = [];
        if (adata.webReqVisibilities.length > 0) {
            for (let i = 0; i < adata.webReqVisibilities.length; i++) {
                wAccessList.push(adata.webReqVisibilities[i].name);
            }
        }
        return wAccessList;
    }

    private getDisplayDefault(aData) {
        if (aData === null) {
            return true;
        } else {
            return aData;
        }
    }    

}
